import { useState } from 'react';

import '../style/Login.css';
import logoSmall from '../assets/logo512.png';

const Login = () => {
  const [role, setRole] = useState<'tenant' | 'landlord'>('tenant');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState<string | null>(null);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('User not found');
    // setTimeout(() => setMessage(null), 3000);
  };

  return (
    <>
      <meta name='robots' content='noindex' />
      <title>REM Login</title>

      <div className='login-page'>
        <form className='login-card' onSubmit={handleLogin}>
          <div className='login-header'>
            <img src={logoSmall} alt='Logo' className='logo-small' />
            <h2>Welcome back</h2>
            <p className='sub'>Sign in to continue</p>
          </div>

          <div className='role-toggle' role='tablist' aria-label='Select role'>
            <div
              className={`role-option ${role === 'tenant' ? 'active' : ''}`}
              onClick={() => setRole('tenant')}
              role='tab'
              aria-selected={role === 'tenant'}
              tabIndex={0}
            >
              Tenant
            </div>
            <div
              className={`role-option ${role === 'landlord' ? 'active' : ''}`}
              onClick={() => setRole('landlord')}
              role='tab'
              aria-selected={role === 'landlord'}
              tabIndex={0}
            >
              Landlord
            </div>
            <div className={`role-indicator ${role}`}></div>
          </div>

          {message ? <div className='message'>{message}</div> : null}

          <label className='field'>
            <span className='label-text'>Email</span>
            <input
              type='text'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder='you@domain.com'
            />
          </label>

          <label className='field'>
            <span className='label-text'>Password</span>
            <input
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder='••••••••'
            />
          </label>

          <button type='submit' className='btn primary'>
            Log in
          </button>

          <button
            type='button'
            className='btn secondary'
            onClick={() =>
              setMessage(
                'Current registrations are done manually! Please contact us for new registrations.'
              )
            }
          >
            Register
          </button>
        </form>
      </div>
    </>
  );
};

export default Login;
